import React, { Component } from 'react';

import {numberWithCommas} from './../../../utils/utils';

import './../../../../scss/App.scss';


class ResultsOverlay extends Component {
	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax({onComplete : this.handleTransitionComplete,
									onCompleteParams:[this],
									onReverseComplete:this.handleTransitionOutComplete, 
									onReverseCompleteParams:[this]});
	}

	componentDidMount(){
		window.TweenMax.set(this.refs.overlay, {"opacity": 0});
		window.TweenMax.set(this.refs.line1, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line2, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.playBtn, {"opacity": 0, "transform":"translateY(1vw)"});


		this.transitionIn.to(this.refs.overlay, .5, {"opacity":1, "delay":.3})
		.to(this.refs.line1, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line2, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.playBtn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
	}

	handleTransitionComplete(_this){

	}

	handleTransitionOutComplete(_this){
		//_this.props.handleNextRound();
	}

	handlePlayBtnClick(){
		//this.transitionIn.reverse();
	}

	render(){

		// determine round message
		const totalRounds = window.config.rounds.length;
		var roundMsg = "ROUND COMPLETE";

		if(totalRounds > 1){
			roundMsg = "ROUND " + this.props.round + " OF " + totalRounds + " COMPLETE";
		}

		// determine play button label
		var playBtnLabel = "NEXT ROUND";

		if( (totalRounds > 1) && (this.props.round === (totalRounds - 1)) ){
			playBtnLabel = "FINAL ROUND";
		}

		return(
			<div className="results_overlay" ref="overlay">
				<div className="content" ref="content">
					<div className="roundMsg" ref="line1">{roundMsg}</div>
					<div className="scoreMsg" ref="line2">This Round: {numberWithCommas(this.props.roundPoints)} points<br/>Total Score: {numberWithCommas(this.props.totalPoints)} points</div>
					{this.props.renderThresholdMsg}
					<div className="nextBtn" ref="playBtn" onClick={()=>this.props.handleNextRound()} onMouseOver={() => window.sounds.buttonHover.play()}>{playBtnLabel}</div>
				</div>
			</div>
		);
	}
}

export default ResultsOverlay;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/results/ResultsOverlay.js